<template>
    <div class="container-fluid">
        <router-view :phases = "phasesWithRoutes"></router-view>
    </div>
</template>

<script>
export default {
    name: "Result",
    data: function() {
        return{
            phases:[],
            phasesWithRoutes:[],
        }
    },
    //runs automatically when the page loads...
    created() {
        this.fetchPhases();
    },
    methods:{
       fetchPhases(){
            let vm = this;
            axios
                .get("/api/phases")
                .then(response => {
                    this.phases = response.data;

                    this.createRoutes();
                })
                .catch(err => console.log(err)); 
                
            //this.phases = [ // fetchPhases
                /*{
                    id: 1,
                    name: 'Planung und Konzeption',
                    hasFrameworkCond: 1,
                }*/
       },
        createRoutes(){
           console.log("function createRoutes entered");
           this.phasesWithRoutes = this.phases.map(phase => ({...phase, route: this.createRouteFromName(phase.Name)}));
           console.log(this.phasesWithRoutes);
        },
        createRouteFromName(name){
            //console.log("function createRouteFromName entered:");
            return name.replaceAll('-', '').replace(/\s/g, '-').toLowerCase();
        }
    }
};
</script>
